import {
  createContext,
  useContext,
  useEffect,
  type ReactNode,
} from 'react';

export interface HeaderSlot {
  row1?: ReactNode;
  overflowPanel?: ReactNode | ((close: () => void) => ReactNode);
  desktopRow2?: ReactNode;
  fab?: ReactNode;
}

type Setter = (slot: HeaderSlot | null) => void;

const SetterCtx = createContext<Setter | null>(null);

export const HeaderSlotSetterProvider = SetterCtx.Provider;

export function useHeaderSlot(slot: HeaderSlot | null): void {
  const setSlot = useContext(SetterCtx);
  useEffect(() => {
    if (!setSlot) return;
    setSlot(slot);
    return () => setSlot(null);
  }, [slot, setSlot]);
}
